import { Button, Form, Input, Typography } from 'antd';

import { Phone } from '@app/components/Phone';

import { usePhoneCodeForm } from '@pages/Integrations/IntegrationsList/components/ConnectIntegrationModal/hooks/usePhoneCodeForm';

import type { FC } from 'react';

const { Text, Link } = Typography;
const { Item } = Form;

export interface PhoneCodeFormProps {
  codeDestinationText: string;
  codeLength: number;
  isCodeStage: boolean;
  resendSecondsLeft: number;
  isPhoneSending: boolean;
  isCodeSending: boolean;
  onSubmitPhone(phone: string): void;
  onSubmitCode(code: string): void;
  onBackToQr(): void;
}

/**
 * Запасной путь архетипа «QR-сессия»: номер → код (task/10730).
 * Локальные форматы номера приводит компонент Phone (8… → +7…).
 */
export const PhoneCodeForm: FC<PhoneCodeFormProps> = ({
  codeDestinationText,
  codeLength,
  isCodeStage,
  resendSecondsLeft,
  isPhoneSending,
  isCodeSending,
  onSubmitPhone,
  onSubmitCode,
  onBackToQr,
}) => {
  const { form, phoneRules, submitPhoneHandler } = usePhoneCodeForm({
    onSubmitPhone,
  });

  if (!isCodeStage) {
    return (
      <Form
        form={form}
        layout="vertical"
        onFinish={submitPhoneHandler}
        className="connect-integration-modal__phone-form"
      >
        <Item label="Номер телефона аккаунта" name="phone" rules={phoneRules}>
          <Phone
            name="phone"
            required
            phoneInputDataTestId="connect-auth-phone"
          />
        </Item>
        <Text type="secondary">
          Можно вводить как привычно: 8 912… — поймём и поправим сами.
        </Text>
        <div className="connect-integration-modal__form-actions">
          <Button
            type="primary"
            htmlType="submit"
            loading={isPhoneSending}
            data-testid="connect-auth-send-phone"
          >
            Получить код
          </Button>
          <Link onClick={onBackToQr}>Вернуться к QR-коду</Link>
        </div>
      </Form>
    );
  }

  return (
    <div className="connect-integration-modal__code-stage">
      <Text type="secondary">{codeDestinationText}</Text>
      <Input.OTP
        length={codeLength}
        onChange={onSubmitCode}
        disabled={isCodeSending}
        data-testid="connect-auth-code"
      />
      <div className="connect-integration-modal__form-actions">
        <Text type="secondary">
          {resendSecondsLeft > 0
            ? `Отправить повторно можно через 0:${String(
                resendSecondsLeft
              ).padStart(2, '0')}`
            : 'Не пришёл код? Вернитесь на шаг назад и отправьте ещё раз.'}
        </Text>
        <Link onClick={onBackToQr}>Вернуться к QR-коду</Link>
      </div>
    </div>
  );
};
